import { render, staticRenderFns } from "./ThirdComponent.vue?vue&type=template&id=a1a72804"
import script from "./ThirdComponent.vue?vue&type=script&lang=js"
export * from "./ThirdComponent.vue?vue&type=script&lang=js"
import style0 from "./ThirdComponent.vue?vue&type=style&index=0&id=a1a72804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports